/* BUKI quick add: size chips on product cards add straight to the bag.
   When a colour swatch (Swatch King) switches a card to another colourway, the size chips no longer match,
   so the card swaps them for a "Choose size" link to that colourway. */
(function () {
  function toast(msg) {
    var t = document.getElementById('bk-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'bk-toast'; t.className = 'bk-toast'; t.setAttribute('role', 'status');
      t.innerHTML = '<p class="bk-toast__msg"></p><div class="bk-toast__actions"><a class="bk-btn bk-btn--ghost" href="/cart">View bag</a><a class="bk-btn" href="/checkout">Checkout</a></div>';
      document.body.appendChild(t);
    }
    t.querySelector('.bk-toast__msg').textContent = msg;
    t.classList.add('is-on'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 5000);
  }
  function bump() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-link__bubble').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', c.item_count > 0); });
      document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:build'));
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bk-qa] button[data-id]'); if (!b || b.disabled) return;
    e.preventDefault();
    var wrap = b.closest('[data-bk-qa]'); b.classList.add('is-busy');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.id), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { b.classList.remove('is-busy'); b.classList.add('is-added'); setTimeout(function () { b.classList.remove('is-added'); }, 1800); toast('Added to bag: ' + wrap.dataset.title + (b.dataset.size ? ' · ' + b.dataset.size : '')); bump(); })
      .catch(function () { b.classList.remove('is-busy'); toast('That size just sold out. Try another.'); });
  });
  function path(u) { try { return new URL(u, location.href).pathname; } catch (e) { return u; } }
  function sync(link) {
    var card = link.closest('.bk-card'); if (!card) return;
    var qa = card.querySelector('[data-bk-qa]'); if (!qa) return;
    var moved = path(link.getAttribute('href')) !== path(link.dataset.bkUrl);
    if (moved) {
      if (!qa._orig) qa._orig = qa.innerHTML;
      qa.innerHTML = '<a class="bk-qa__btn bk-qa__btn--wide" href="' + link.getAttribute('href') + '">Choose size</a>';
      qa.dataset.swapped = '1';
    } else if (qa.dataset.swapped && qa._orig) {
      qa.innerHTML = qa._orig; delete qa.dataset.swapped;
    }
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      list.forEach(function (m) { if (m.target.matches && m.target.matches('a.bk-card__link[data-bk-url]')) sync(m.target); });
    }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['href'] });
  }
})();